/**
 * Trigger: tr_creditor_payments_insert
 * Purpose: Update account balances and creditor totals when a creditor payment is inserted
 * Table: creditor_payments
 * Event: AFTER INSERT
 */
export const TR_CREDITOR_PAYMENTS_INSERT = `
CREATE TRIGGER tr_creditor_payments_insert
AFTER INSERT ON creditor_payments FOR EACH ROW
BEGIN
  UPDATE account_balances
  SET creditor_payments_amount = creditor_payments_amount + new.amount
  WHERE account_id = new.account_id
    AND currency_id = new.currency_id;

  INSERT OR IGNORE INTO account_daily_balances(account_id, currency_id, balance_date)
  VALUES (new.account_id, new.currency_id, new.payment_date);

  INSERT OR IGNORE INTO account_activity_dates(account_id, activity_date)
  VALUES (new.account_id, new.payment_date);

  UPDATE account_daily_balances
  SET creditor_payments_amount = creditor_payments_amount + new.amount
  WHERE account_id = new.account_id
    AND currency_id = new.currency_id
    AND balance_date = new.payment_date;

  UPDATE creditors
  SET total_amount = total_amount + new.amount
  WHERE _id = new.creditor_id;

  INSERT OR IGNORE INTO exchange_rates (rate_date, rate, currency_id)
  SELECT new.payment_date, new.exchange_rate, new.currency_id
  WHERE new.exchange_rate > 0;
END;
`;
